export default {
    SET_VALIDATION_MESSAGES : 'SET_VALIDATION_MESSAGES',
    SET_SELECTED_REPORT_TYPE : 'SET_SELECTED_REPORT_TYPE',    
    SET_FILTER_TEXT_TYPE : 'SET_FILTER_TEXT_TYPE'    
}